// extracted by mini-css-extract-plugin
export default {"report-categories-page":"ReportCategoriesPage_report-categories-page__wDC4M"};